import React from 'react';

const RemoveIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
  >
    <rect width="18" height="18" rx="9" fill="#E7E7E7" />
    <path d="M5.00003 5L13 12.9999M13 5.00006L5 13" stroke="#002424" />
  </svg>
);

export default RemoveIcon;
